import apiClient from './apiClient';

/**
 * @param {number} month 1-12
 * @param {number} year
 * @param {{ activityId: number, tenantId?: number|null, tag_number?: string, alias?: string }} options
 */
export const getMonthlyAttendance = async (month, year, options = {}) => {
    const { activityId, tenantId, ...filters } = options;
    try {
        const params = { month, year, activity_id: activityId, ...filters };
        if (tenantId != null && !Number.isNaN(tenantId)) {
            params.tenant_id = tenantId;
        }
        const response = await apiClient.get('/stock-taking/monthly-report', { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * @param {{ tenantId?: number | null }} options Pass tenantId for platform admins (query param).
 */
export const getAllAnimals = async ({ tenantId = null } = {}) => {
    try {
        const perPage = 100;
        let page = 1;
        const all = [];
        while (true) {
            const params = { page, per_page: perPage };
            if (tenantId != null && !Number.isNaN(tenantId)) {
                params.tenant_id = tenantId;
            }
            const response = await apiClient.get('/animal/get_animals', { params });
            const data = response.data || {};
            const items = Array.isArray(data.items) ? data.items : [];
            all.push(...items);
            const total = data.total;
            if (items.length < perPage || items.length === 0) break;
            if (typeof total === 'number' && all.length >= total) break;
            page += 1;
            if (page > 500) break;
        }
        return all;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * @param {object} record animal_id, date, status, notes, activity_id
 * @param {{ tenantId?: number|null }} options
 */
export const saveAttendanceRecord = async (record, { tenantId = null } = {}) => {
    try {
        const params = {};
        if (tenantId != null && !Number.isNaN(tenantId)) {
            params.tenant_id = tenantId;
        }
        const response = await apiClient.post(
            '/stock-taking/record',
            {
                animal_id: record.animal_id,
                date: record.date,
                status: record.status,
                notes: record.notes,
                activity_id: record.activity_id,
            },
            { params }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * @param {object[]} records
 * @param {{ tenantId?: number|null }} options
 */
export const saveAllAttendance = async (records, { tenantId = null } = {}) => {
    try {
        const params = {};
        if (tenantId != null && !Number.isNaN(tenantId)) {
            params.tenant_id = tenantId;
        }
        const response = await apiClient.post('/stock-taking/records', records, {
            params,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * @param {number} month
 * @param {number} year
 * @param {{ format?: string, activityId: number, tenantId?: number|null }} options
 */
export const exportAttendanceReport = async (
    month,
    year,
    { format = 'csv', activityId, tenantId = null } = {}
) => {
    try {
        const params = { month, year, format, activity_id: activityId };
        if (tenantId != null && !Number.isNaN(tenantId)) {
            params.tenant_id = tenantId;
        }
        const response = await apiClient.get('/stock-taking/export-report', {
            params,
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * @param {number} activityId
 * @param {{ tenantId?: number|null }} options
 */
export const getActivityStockSummary = async (activityId, { tenantId = null } = {}) => {
    try {
        const params = {};
        if (tenantId != null && !Number.isNaN(tenantId)) {
            params.tenant_id = tenantId;
        }
        const response = await apiClient.get(
            `/stock-taking/activity/${activityId}/summary`,
            { params }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
